export default {
    continueReading: "Para continuar leyendo por favor",
    doYouHaveAnAccount: "¿Ya posee una cuenta?",
    loginHere: "Iniciar sesión",
    acceptAndContinueReading: "Aceptar y continuar leyendo",
};
